import MetaSeo from '@/components/MetaSeo';
import Device from '../../components/Device/index';
import BreadcrumbComponent from '@/components/Other/BreadCrumbComponent';
import useTrans from '@/hooks/useTrans';
import styles from '../BusinessSolutions/businesssolutions.module.css';

export default function BusinessSolutions(props) {
  const trans = useTrans();

  const listReport = [
    {
      sastify_percent: 90,
      sasitfy_title: trans.business_solutions.survey_report.sastify.sastify_1,
      unsastify_percent: 10,
      unsastify_title:
        trans.business_solutions.survey_report.unsastify.unsastify_1,
      report_description: trans.business_solutions.survey_report.description_1,
      image: '../assets/img/business_solutions/report_1.png',
    },
    {
      sastify_percent: 78,
      sasitfy_title: trans.business_solutions.survey_report.sastify.sastify_2,
      unsastify_percent: 22,
      unsastify_title:
        trans.business_solutions.survey_report.unsastify.unsastify_2,
      report_description: trans.business_solutions.survey_report.description_2,
      image: '../assets/img/business_solutions/report_2.png',
    },
    {
      sastify_percent: 70,
      sasitfy_title: trans.business_solutions.survey_report.sastify.sastify_3,
      unsastify_percent: 30,
      unsastify_title:
        trans.business_solutions.survey_report.unsastify.unsastify_3,
      report_description: trans.business_solutions.survey_report.description_3,
      image: '../assets/img/business_solutions/report_3.png',
    },
  ];

  const listExpense = [
    {
      title: trans.business_solutions.survey_expense.expenses,
      percent: '2-7',
      company: trans.business_solutions.survey_expense.b2b_company,
    },
    {
      title: trans.business_solutions.survey_expense.reward,
      percent: '15',
      company: trans.business_solutions.survey_expense.salary,
    },
    {
      title: trans.business_solutions.survey_expense.expenses,
      percent: '5-12',
      company: trans.business_solutions.survey_expense.b2c_company,
    },
  ];

  const listFeature = [
    {
      image: '../assets/img/business_solutions/feature_1.svg',
      title: trans.business_solutions.another_feature.item_1.title,
      description: trans.business_solutions.another_feature.item_1.description,
      url: 'https://hanagold.vn/huong-dan-giai-dap-tinh-nang-cung-hop-tac',
    },
    {
      image: '../assets/img/business_solutions/feature_2.svg',
      title: trans.business_solutions.another_feature.item_2.title,
      description: trans.business_solutions.another_feature.item_2.description,
      url:
        'https://hanagold.vn/huong-dan-tich-luy-nhan-thuong-moi-ngay-tai-hanagold',
    },
    {
      image: '../assets/img/business_solutions/feature_3.svg',
      title: trans.business_solutions.another_feature.item_3.title,
      description: trans.business_solutions.another_feature.item_3.description,
      url: 'https://hanagold.vn/huong-dan-tao-va-nhan-qua-tang-e-voucher',
    },
  ];

  const dataSeo = {
    title: 'HanaGold Doanh nghiệp',
    description: 'Giải pháp tặng thưởng đa dạng và linh hoạt cho các doanh nghiệp nhằm xây dựng mối quan hệ lâu dài với khách hàng và tạo động lực cho nhân viên, cùng Doanh nghiệp phát triển bền vững.',
    image: 'https://api.hanagold.vn/media-new/1728269203481-giai-phap-doanh-nghieppng.png',
    url: 'https://hanagold.vn/giai-phap-doanh-nghiep'
  };

  return (
    <>
      <MetaSeo {...dataSeo} />
      <section id='business_solutions'>
        <div className='priority_breadcrumb_container'>
          <BreadcrumbComponent title={trans.business_solutions.title} url='giai-phap-doanh-nghiep'/>
        </div>
        <div className={styles.banner_business}>
          <div className={styles.business_solutions_container}>
            <div
              className={styles.banner_content_business}
              data-aos='fade-down'
              data-aos-delay='350'
            >
              <h1>
                <span>{trans.business_solutions.banner_title_1}</span>{' '}
                {trans.business_solutions.banner_title_2}
              </h1>
              <p>{trans.business_solutions.banner_description}</p>
            </div>
          </div>
        </div>
        <div className='c-home-about-us'>
          <h2 className='c-home-about__h2' data-aos='fade-left'>
            {trans.business_solutions.about_title}
          </h2>
          <div className='c-home-about__h2__text' data-aos='fade-left'>
            <Device>
              {({ isMobile }) => (
                <>
                  {isMobile && (
                    <>
                      <p className='c-home-about__description_h2'>
                        {trans.business_solutions.about_description_1}
                      </p>
                      <p className='c-home-about__description_h2 pt-16'>
                        {trans.business_solutions.about_description_2}
                      </p>
                    </>
                  )}
                  {!isMobile && (
                    <>
                      <p className='c-home-about__description_h2'>
                        {trans.business_solutions.about_description_3}
                      </p>
                      <p className='c-home-about__description_h2'>
                        {trans.business_solutions.about_description_4}
                      </p>
                      <p className='c-home-about__description_h2'>
                        {trans.business_solutions.about_description_5}
                      </p>
                    </>
                  )}
                </>
              )}
            </Device>
          </div>
        </div>
        <div className={styles.dedicated_solution}>
          <div className={styles.business_solutions_container}>
            <h2 data-aos='fade-right' data-aos-delay='600'>
              {trans.business_solutions.dedicated_solution_1}{' '}
              <span> {trans.business_solutions.dedicated_solution_2}</span>
            </h2>
            <div
              className={styles.dedicated_solution_list}
              data-aos='fade-down'
              data-aos-delay='650'
            >
              <div className={styles.dedicated_solution_item}>
                <div className={styles.dedicated_solution_item_img}>
                  <img
                    src='../../assets/img/business_solutions/dedicated_solution_star.png'
                    alt='item_star'
                    className='animate-star-move-left-zoom'
                  />
                </div>
                <div className={styles.dedicated_solution_item_title}>
                  <h3>HANAGOLD REWARD</h3>
                </div>
                <div className={styles.dedicated_solution_item_detail}>
                  <p>
                    {trans.business_solutions.hanagold_reward.description_1}
                  </p>
                  <p>
                    {trans.business_solutions.hanagold_reward.description_2}
                  </p>
                </div>
              </div>
              <div className={styles.dedicated_solution_item}>
                <div className={styles.dedicated_solution_item_img}>
                  <img
                    src='../../assets/img/business_solutions/dedicated_solution_medal.png'
                    alt='item_medal'
                    className='animate-star-move-left-zoom'
                  />
                </div>
                <div className={styles.dedicated_solution_item_title}>
                  <h3>HANAGOLD LOYALTY</h3>
                </div>
                <div className={styles.dedicated_solution_item_detail}>
                  <p>
                    {trans.business_solutions.hanagold_loyalty.description_1}
                  </p>
                  <p>
                    {trans.business_solutions.hanagold_loyalty.description_2}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.survey_report}>
          <div className={styles.business_solutions_container}>
            <div
              className={styles.survey_report_title}
              data-aos='fade-left'
              data-aos-delay='600'
            >
              <h2>
                <span>{trans.business_solutions.survey_report.title_1} </span>{' '}
                {trans.business_solutions.survey_report.title_2}
              </h2>
              <p>{trans.business_solutions.survey_report.description}</p>
            </div>
            <div className={`${styles.list_report} ${styles.report_pc}`}>
              {listReport?.map((_rp, _indexRp) => {
                return (
                  <div
                    key={_indexRp}
                    className={styles.report_item}
                    data-aos='fade-up'
                    data-aos-delay='600'
                  >
                    <div className={styles.report_item_title_above}>
                      <div>
                        <p className={styles.percent}>{_rp?.unsastify_percent}%</p>
                        <p className={styles.title}>{_rp?.unsastify_title}</p>
                      </div>
                      <div>
                        <img
                          src='../assets/img/business_solutions/vector_left.png'
                          alt=''
                          style={{ width: '58.5px', height: '82px' }}
                        />
                      </div>
                    </div>
                    <div className='report_item-img'>
                      <img
                        src={_rp?.image}
                        alt={`image_report_${_indexRp + 1}`}
                        style={{ width: '268.182px', height: '268.182px' }}
                      />
                    </div>
                    <div
                      className={`${styles.report_item_title_bottom} ${styles[`item_${_indexRp + 1}`]}`}
                    >
                      <div>
                        <img
                          src='../assets/img/business_solutions/vector_right.png'
                          alt=''
                          style={{ width: '58.5px', height: '82px' }}
                        />
                      </div>
                      <div className={styles.report_item_title_bottom_text}>
                        <p className={styles.percent}>{_rp?.sastify_percent}%</p>
                        <p className={styles.title}>{_rp?.sasitfy_title}</p>
                      </div>
                    </div>
                    <div className={styles.report_item_description}>
                      <p>{_rp?.report_description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className={`${styles.list_report} ${styles.report_mb}`}>
              {listReport?.map((_rp, _indexRp) => {
                return (
                  <div key={_indexRp} className={styles.report_item}>
                    <p className={styles.report_item_description_mb}>
                      {_rp?.report_description}
                    </p>
                    <div className={styles.report_item_information}>
                      <img
                        src={_rp?.image}
                        alt={`image_report_${_indexRp + 1}`}
                        style={{ width: '143.78px', height: '143.78px' }}
                      />
                      <div className={styles.report_item_text}>
                        <div>
                          <p className={styles.percent}>{_rp?.unsastify_percent}%</p>
                          <p className={styles.title_mb}>{_rp?.unsastify_title}</p>
                        </div>
                        <div>
                          <p className={styles.percent}>{_rp?.sastify_percent}%</p>
                          <p className={styles.title_mb}>{_rp?.sasitfy_title}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className={styles.survey_expense}>
          <div className={styles.business_solutions_container}>
            <div className={styles.survey_expense_title}>
              <h2 data-aos='fade-left' data-aos-delay='600'>
                <span>{trans.business_solutions.survey_expense.title_1} </span>
                {trans.business_solutions.survey_expense.title_2}
              </h2>
            </div>
            <div className={`${styles.survey_expense_list} ${styles.list_pc}`}>
              {listExpense?.map((_exp, _indexExp) => {
                return (
                  <div
                    key={_indexExp}
                    className={`${
                      _indexExp === 1
                        ? styles.border_survey_expense_big
                        : styles.border_survey_expense_small
                    } ${styles.survey_expense_item}`}
                    data-aos='fade-down'
                    data-aos-delay='600'
                  >
                    <p
                      className={`${
                        _indexExp === 1
                          ? styles.title_big
                          : ''
                      } ${styles.surver_expense_item_title}`}
                    >
                      {_exp?.title}
                    </p>
                    <p
                      className={`${
                        _indexExp === 1
                          ? styles.percent_big
                          : ''
                      } ${styles.surver_expense_item_percent}`}
                    >
                      {_exp?.percent}%
                    </p>
                    <p
                      className={`${
                        _indexExp === 1
                          ? styles.company_big
                          : ''
                      } ${styles.surver_expense_item_company}`}
                    >
                      {_exp?.company}
                    </p>
                  </div>
                );
              })}
            </div>
            <div className={`${styles.survey_expense_list} ${styles.list_mb}`}>
              <div
                className={styles.survey_expense_item_mb_big}
                data-aos='fade-up'
                data-aos-delay='600'
              >
                <p className={styles.title}>
                  {trans.business_solutions.survey_expense.reward}
                </p>
                <p className={styles.percent}>15%</p>
                <p className={styles.description}>
                  {trans.business_solutions.survey_expense.salary}
                </p>
              </div>
              <div className={styles.survey_expense_item_mb_list}>
                <div
                  className={styles.survey_expense_item_mb_small}
                  data-aos='fade-right'
                  data-aos-delay='600'
                >
                  <p className={styles.title}>
                    {trans.business_solutions.survey_expense.expenses}
                  </p>
                  <p className={styles.percent}>2-7%</p>
                  <p className={styles.description}>
                    {trans.business_solutions.survey_expense.b2b_company}
                  </p>
                </div>
                <div
                  className={styles.survey_expense_item_mb_small}
                  data-aos='fade-left'
                  data-aos-delay='600'
                >
                  <p className={styles.title}>
                    {trans.business_solutions.survey_expense.expenses}
                  </p>
                  <p className={styles.percent}>5-12%</p>
                  <p className={styles.description}>
                    {trans.business_solutions.survey_expense.b2b_company}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.benefit_solution}>
          <div className={styles.business_solutions_container}>
            <h2
              className={styles.benefit_solution_title}
              data-aos='fade-left'
              data-aos-delay='600'
            >
              {trans.business_solutions.benefit_solution.title}
            </h2>
            <div className={styles.benefit_solution_list}>
              <div className={styles.benefit_solution_list_left}>
                <div
                  className={styles.benefit_solution_item_above}
                  data-aos='fade-down'
                  data-aos-delay='600'
                >
                  <p>
                    {trans.business_solutions.benefit_solution.description_1}
                  </p>
                </div>
                <div
                  className={styles.benefit_solution_item_bottom}
                  data-aos='fade-up'
                  data-aos-delay='600'
                >
                  <div className={styles.benefit_solution_item_small}>
                    <p>
                      {trans.business_solutions.benefit_solution.description_2}
                    </p>
                  </div>
                  <div className={styles.benefit_solution_item_small}>
                    <p>
                      {trans.business_solutions.benefit_solution.description_3}
                    </p>
                  </div>
                </div>
              </div>
              <div
                className={styles.benefit_solution_item_betwwen}
                data-aos='fade-down'
                data-aos-delay='600'
              >
                <p>{trans.business_solutions.benefit_solution.description_4}</p>
              </div>
              <div
                className={styles.benefit_solution_list_right}
                data-aos='fade-left'
                data-aos-delay='600'
              >
                <div className={styles.benefit_solution_list_right_item}>
                  <p>
                    {' '}
                    {trans.business_solutions.benefit_solution.description_5}
                  </p>
                </div>
                <div className={styles.benefit_solution_list_right_item}>
                  <p>
                    {' '}
                    {trans.business_solutions.benefit_solution.description_6}
                  </p>
                </div>
                <div className={styles.benefit_solution_list_right_item}>
                  <p>
                    {' '}
                    {trans.business_solutions.benefit_solution.description_7}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.another_feature}>
          <div className={styles.business_solutions_container}>
            <div className={styles.another_feature_container}>
              <div className={styles.another_feature_title}>
                <h2 data-aos='fade-right' data-aos-delay='600'>
                  <span>
                    {trans.business_solutions.another_feature.title_1}{' '}
                  </span>
                  {trans.business_solutions.another_feature.title_2}
                </h2>
              </div>
              <div
                className={styles.another_feature_list}
                data-aos='fade-left'
                data-aos-delay='600'
              >
                {listFeature?.map((_feature, _indexFeature) => {
                  return (
                    <a
                      key={_indexFeature}
                      className={styles.another_feature_list_item}
                      href={_feature?.url}
                      target='_blank'
                    >
                      <div className={styles.another_feature_list_item_img}>
                        <img
                          src={_feature?.image}
                          alt={`feature_${_indexFeature + 1}`}
                        />
                      </div>
                      <div className={styles.another_feature_list_item_text}>
                        <p className={styles.title_another_feature}>
                          {_feature?.title}
                        </p>
                        <p className={styles.description_another_feature}>
                          {_feature?.description}
                        </p>
                        <div className={styles.another_feature_button}>
                          <a href={_feature?.url} target='_blank'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='34'
                              height='34'
                              viewBox='0 0 34 34'
                              fill='none'
                            >
                              <path
                                d='M23.2196 14.2749L10.2292 21.7749C10.057 21.8744 9.85226 21.9013 9.66013 21.8498C9.46799 21.7983 9.30418 21.6726 9.20472 21.5004C9.10527 21.3281 9.07831 21.1234 9.1298 20.9313C9.18128 20.7391 9.30698 20.5753 9.47924 20.4759L22.4696 12.9759C22.6419 12.8764 22.8466 12.8495 23.0387 12.9009C23.2309 12.9524 23.3947 13.0781 23.4941 13.2504C23.5936 13.4226 23.6205 13.6274 23.5691 13.8195C23.5176 14.0116 23.3919 14.1754 23.2196 14.2749Z'
                                fill='#1A1A1A'
                              />
                              <path
                                d='M22.9158 13.6933L16.9262 12.3646C16.7906 12.3345 16.6772 12.253 16.6108 12.138C16.5444 12.023 16.5305 11.884 16.5723 11.7515C16.614 11.619 16.7079 11.5039 16.8333 11.4315C16.9587 11.3591 17.1054 11.3353 17.241 11.3654L23.7409 12.8082C23.8081 12.823 23.8706 12.8506 23.9248 12.8895C23.979 12.9284 24.0238 12.9777 24.0566 13.0346C24.0895 13.0916 24.1098 13.155 24.1164 13.2214C24.1229 13.2877 24.1156 13.3556 24.0949 13.4213L22.0944 19.7717C22.0526 19.9042 21.9587 20.0193 21.8333 20.0917C21.7079 20.1642 21.5613 20.1879 21.4257 20.1578C21.2901 20.1277 21.1766 20.0462 21.1102 19.9312C21.0438 19.8163 21.03 19.6772 21.0717 19.5447L22.9158 13.6933Z'
                                fill='#1A1A1A'
                              />
                            </svg>
                            {
                              trans.business_solutions.another_feature
                                .button_view_more
                            }
                          </a>
                        </div>
                      </div>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.guide_use}>
          <div className={styles.business_solutions_container}>
            <div className={styles.guide_use_container}>
              <div
                className={styles.guide_use_container_block}
                data-aos='fade-left'
                data-aos-delay='600'
              >
                <h2>{trans.business_solutions.guide_use.title}</h2>
                <p>{trans.business_solutions.guide_use.description}</p>
                <div className={styles.guide_use_button}>
                  <a
                    href='https://hanagold.vn/huong-dan-dang-ky-tai-khoan-doanh-nghiep'
                    target='_blank'
                  >
                    {trans.business_solutions.guide_use.button_guide}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
